(function ($) {
  powerCouplesRowMobile = {
    formatter: $('.power-couples-row-mobile-v1')
  };

  Drupal.behaviors.powerCouplesRowMobile = {
    get: function (key) {
      return powerCouplesRowMobile[key];
    },

    set: function (key, val) {
      powerCouplesRowMobile[key] = val;
    },

    attach: function (context, settings) {
      if ($('body').hasClass('device-mobile')) {
        var self = this;
        var formatter = self.get('formatter');

        site.mpp.data = {
          category: page_data['product-input-type'],
          categories: page_data['product-input-type']
        };
        site.mpp.init();

        formatter.each(function () {
          var thisFormatter = $(this);

          // Accordion Functionality
          thisFormatter.find('h3').on('click', function() {
            var $h3 = $(this);

            $h3.toggleClass('selected');
            $h3.parent().siblings().children('h3').removeClass('selected');
            $h3.parent().siblings().find('h3').next().hide();
            var $h3 = $(this);

            $(this).next().slideToggle(500, function () {
              $('body, html').scrollTo($h3, {
                duration: 500,
                axis: 'y'
              });
            });
          });
        });

        $('.button.cta', context).on('click', function(e) {
          e.preventDefault();
          var both_btn = e.target;

          $('.button.cta', context).removeClass('disabled');
          $(both_btn).addClass('disabled');
          var qs_arr = [];

          $(both_btn).parents('.row-products').find('.product[data-productid]').each(function (j, prod_div) {
            var prodId = $(prod_div).attr('data-productid');
            var product = page_data['product-input-type'].products.filter(function (p) {
              return p !== null ? p.PRODUCT_ID === prodId : false;
            })[0];
            var count_valid = 0;
            var sku, undef;

            for (var i = 0; i < product.skus.length; i++) {
              var o_sku = $(document).data(product.skus[i].SKU_ID);

              if ((o_sku !== undef) && ((o_sku.isOrderable == 1) || (o_sku.INVENTORY_STATUS == 3) || (o_sku.INVENTORY_STATUS == 2 && Drupal.settings.display_notify_tos))) {
                if (sku === undef) {
                  sku = product.skus[i];
                }
                count_valid++;
              }
            }

            qs_arr[j] = {
              product_data: product,
              valid_skus: count_valid,
              first_valid_sku: sku
            };
          });

          // code to show combined price - commented out per bug#170006 comment#4
          /*
        var price_1 = qs_arr[0].first_valid_sku.PRICE;
        var price_2 = qs_arr[1].first_valid_sku.PRICE;
        $(both_btn).parents('.row-products').find('.multi-products-price').html(parseFloat(price_1 + price_2).toFixed(2));
        $('.both_price').removeClass('hidden');
        $(document).bind('sku:select', function(e, skuData) {
          var undef;
          var sku1 = qs_arr[0].product_data.skus.filter(function(s){
            return String(s.SKU_BASE_ID) === String(skuData.SKU_BASE_ID);
          })[0];
          if(sku1 !== undef){
            price_1 = sku1.PRICE;
          } else {
            sku2 = qs_arr[1].product_data.skus.filter(function(s){
              return String(s.SKU_BASE_ID) === String(skuData.SKU_BASE_ID);
            })[0];
            if(sku2 !== undef){
              price_2 = sku2.PRICE;
            }
          }
          $(both_btn).parents('.row-products').find('.multi-products-price').html(parseFloat(price_1 + price_2).toFixed(2));
        });
        */
          // adjust scroll position
          if ((qs_arr[0].valid_skus > 1) || (qs_arr[1].valid_skus > 1)) {
            var move_down = $('li[data-productid="' + qs_arr[0].product_data.PRODUCT_ID + '"]').parent().height();

            $('html,body').animate({
              scrollTop: $(window).scrollTop() + move_down
            });
          }

          Drupal.behaviors.powerCouplesRowMobile.processFirstSku(qs_arr, both_btn);
        });
      }
    },

    processFirstSku: function (qs_arr, both_btn) {
      var prodId = qs_arr[0].product_data.PRODUCT_ID;

      $(both_btn).attr('sku_0', qs_arr[0].first_valid_sku.SKU_BASE_ID);
      if (qs_arr[0].valid_skus > 1) {
        $('li[data-productid="' + prodId + '"]').parent().removeClass('hidden');
        $('li[data-productid="' + prodId + '"]').find('.button.continue').on('click', function(evt) {
          evt.preventDefault();
          var selected_value = $('li[data-productid="' + prodId + '"] a.sbSelector').html();
          var selected_sku_id = $('ul.sbOptions a').filter(function () {
            return $(this).text() == selected_value;
          }).attr('rel');

          $(both_btn).attr('sku_0', selected_sku_id);
          $('li[data-productid="' + prodId + '"]').parent().addClass('hidden');
          // process second product
          Drupal.behaviors.powerCouplesRowMobile.processSecondSku(qs_arr, both_btn);
        });
      } else {
      // process second product
        Drupal.behaviors.powerCouplesRowMobile.processSecondSku(qs_arr, both_btn);
      }
    },

    processSecondSku: function (qs_arr, both_btn) {
      var prodId = qs_arr[1].product_data.PRODUCT_ID;

      $(both_btn).attr('sku_1', qs_arr[1].first_valid_sku.SKU_BASE_ID);
      if (qs_arr[1].valid_skus > 1) {
        $('li[data-productid="' + prodId + '"]').parent().removeClass('hidden');
        $('li[data-productid="' + prodId + '"]').find('.button.continue').unbind().on('click', function(evt) {
          evt.preventDefault();
          var selected_value = $('li[data-productid="' + prodId + '"] a.sbSelector').html();
          var selected_sku_id = $('ul.sbOptions a').filter(function () {
            return $(this).text() == selected_value;
          }).attr('rel');

          $(both_btn).attr('sku_1', selected_sku_id);
          $('li[data-productid="' + prodId + '"]').parent().addClass('hidden');
          $('.button.cta').removeClass('disabled');
          site.addToCart({
            skuBaseId: [$(both_btn).attr('sku_0'), $(both_btn).attr('sku_1')]
          });
        });
      } else {
        $('.button.cta').removeClass('disabled');
        site.addToCart({
          skuBaseId: [$(both_btn).attr('sku_0'), $(both_btn).attr('sku_1')]
        });
      }
    }
  };
})(jQuery);
